// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__20gMX","errors":"Errors_errors__3O8LG"};